export const capitalDecreaseModalInitValue = {
  data: {
    date: '',
    sharesToDecrease: 0,
    totalSharesToDecrease: 0,
    societyActualShares: 0,
    comments: '',
    file: undefined,
    notaryName: '',
    notaryProtocol: '',
    notaryCity: '',
    scriptureView: true,
    remainingShares: 0,
    selectedPartner: '',
    selectedPartnerOption: null,
    partnerOptions: [],
    selectedHoldingClass: '',
    holdingClassOptions: [],
    selectedHoldingClassOption: { label: '', value: '' },
    sharesRanges: [],
    shareFrom: 0,
    shareTo: 0,
    hasCustomSharePrice: false,
    sharePrice: 0,
    availableRanges: [],
    lastOperationDate: '',
    historyMovements: [],
    rangesPage: 1,
    rangesRowsPerPage: 10,
    totalAvailableRanges: 0,
    isValidRange: true,
    isValidatingRange: false,
    isLoadingAvailableRanges: false,
    isLoading: false,
  },
  actions: {
    handleCloseModal(): void {},
    handleChangeDate(): void {},
    handleChangeTotalSharesToDecrease(): void {},
    handleChangeComments(): void {},
    handleChangeFile(): void {},
    onChangeNotaryName(): void {},
    onChangeNotaryProtocol(): void {},
    onChangeNotaryCity(): void {},
    handleChangePartner(): void {},
    handleSearchPartnerByTerm: async (): Promise<undefined> => undefined,
    handleChangeHoldingClass(): void {},
    handleFetchHoldingClassByTerm: async (): Promise<undefined> => undefined,
    handleChangeSharesToDecrease(): void {},
    handleChangeRangeFrom(): void {},
    handleChangeRangeTo(): void {},
    handleValidateRange(): void {},
    handleChangeShareFrom(): void {},
    handleChangeShareTo(): void {},
    handleChangeHasCustomSharePrice(): void {},
    handleChangeSharePrice(): void {},
    handleClickRange(): void {},
    handleChangeRangesPage(): void {},
    handleChangeRangesRowsPerPage(): void {},
    handleSaveMovement(): void {},
    handleSaveCapitalDecrease(): void {},
    handleUploadMock(): void {},
  },
};
